"use client";

import { text } from "@/static/text";
import PicFrame from "../PicFrame";
import { MoveLeft } from "lucide-react";
import ExhibitionImage from "@/public/image/exhibition.png";
import LandingSection from "../LandingSection";

export default function Exhibition() {
  return (
    <LandingSection 
      title={text.exhibition.title} 
      desc={text.exhibition.desc}
    >
      <PicFrame 
        icon={MoveLeft} 
        btnText={text.exhibition.btn}
        href="/about-us#collaboration"
        imageSrc={ExhibitionImage}
        imageAlt=" نمایشگاه محصولات اسمارت"
        videoSrc="/video/smart.mp4"
      />
    </LandingSection>
  );
}
